import Box from '@mui/material/Box';
import { InfoTile } from '@openx/components-core/lib/InfoTile/InfoTile';
import {
  RadioComponentSwitchFilled,
  type RadioComponentSwitchFilledOptionProps,
} from '@openx/components-core/lib/RadioComponentSwitchFilled/RadioComponentSwitchFilled';
import { rboConfigMode } from '@openx/types/deal';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type PerformanceQualityFilterProps = {
  radioOptions: RadioComponentSwitchFilledOptionProps[];
  disabled?: boolean;
  onSwitchChange: (value: string) => void;
  value?: string | null;
};

export const PerformanceQualityFilter = ({
  radioOptions,
  disabled = false,
  onSwitchChange,
  value,
}: PerformanceQualityFilterProps) => {
  const { t } = useTranslation();

  const maxModeTip = useMemo(() => {
    if (value !== rboConfigMode.MAX) return null;

    return (
      <InfoTile
        closeable
        item={{
          title: t('Max Targeting Tips'),
          body: t(
            'For optimal performance, broader deal targeting (e.g., inventory, audience, geo) gives Max more reach to optimize.'
          ),
        }}
        data-test="max-targeting-tips"
      />
    );
  }, [t, value]);

  return (
    <Box data-test="performance-quality-filter-container" sx={{ marginTop: 2 }}>
      <RadioComponentSwitchFilled
        onSwitchChange={onSwitchChange}
        value={value}
        radioOptions={radioOptions}
        disabled={disabled}
      >
        {!disabled && (
          <>
            {maxModeTip}
            <InfoTile
              severity="warning"
              item={{
                body: (
                  <>
                    {t(
                      'Engagement optimization traffic shaping is only active when Banner or Video Inventory Targeting is applied to the deal package.'
                    )}
                    <Box sx={{ mt: 1 }}>
                      {t(
                        'The feature is eligible only for deals targeting the USA, Canada, UK, France, Germany, Brazil, Australia, Japan, Singapore, Hong Kong and Mexico. Traffic from other countries will be filtered when it is applied.'
                      )}
                    </Box>
                  </>
                ),
              }}
              data-test="results-traffic-shaping-info"
            />
          </>
        )}
      </RadioComponentSwitchFilled>
    </Box>
  );
};
